import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_BO_DEMO_ILO1 = {
  title: `<span style="font-size: 62px; line-height: 60px;">Customizable dashboards with\n analytics driven insights for\n monitoring business and process\n metrics resulting in notifications\n indicating further actions</span>`,
  subtitle: "Business Operations Demo",
  text: "Improve customer experience through 360 \ndegree view and OPEX reduction by giving a \nholistic view of status of orders",
  label: { iconPath: "start.png", text: "Command Centre" },
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_105"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_103"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO1/ILO1_demo_screens_base.png",
  rightSideVideo: "ILO/ILO1/INF_CMT_827.23_Business Demo_Part 1_R1.mp4",
  pageNumber: "ILO_104",
};

export default DATA_BO_DEMO_ILO1;
